import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";

export default function CollectionCards() {
  const [collectionData, setCollectionData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const storedCollection = localStorage.getItem("selectedCollection");
    if (storedCollection) {
      setCollectionData(JSON.parse(storedCollection));
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  }, []);

  return (
    <div style={{ padding: "20px", marginTop: "15%", paddingBottom: "20%" }}>
      {isLoading ? (
        <CircularProgress />
      ) : collectionData && collectionData.urls ? (
        <div>
          <Typography variant="h4">Cartes de la Collection</Typography>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              marginTop: "20px",
            }}>
            {collectionData.urls.map((url, index) => (
              <img
                key={index}
                src={url}
                alt={`Carte ${index}`}
                style={{ width: "150px", height: "150px", objectFit: "cover" }}
              />
            ))}
          </div>
        </div>
      ) : (
        <Typography variant="body1" color="textSecondary">
          Aucune carte trouvée.
        </Typography>
      )}
    </div>
  );
}
